
























































































































import { Component, Prop, Inject, Vue } from "vue-property-decorator";

import { hotelInfo } from "@/config/host.config";
import { deleteElement } from "@/api/delite/delite-element";
import { IHotelInfo } from "@/@types/hotel-info/info";

import ChangeDeliteButtons from "@/components/buttons/change-delite-buttons.vue";
import ContextMenu from "@/components/buttons/context-menu.vue";
import BSwitch from "@/components/app/switchs/b-switch.vue";

@Component({
  components: { ChangeDeliteButtons, BSwitch, ContextMenu },
})
export default class FullHotelInfoRecyclerList extends Vue {
  @Prop({ type: Object, default: null }) info!: IHotelInfo;
  @Prop({ type: String, default: "" }) theCard!: string;
  @Inject("backgroundFolder") readonly backgroundFolder!: string;
  @Inject("imageFolder") readonly imageFolder!: string;

  constxtID = "";
  $refs!: {
    menu: ContextMenu;
  };

  handler(e: PointerEvent, id: string | undefined): void {
    e.preventDefault();
    if (!id) return;
    this.$nextTick(() => {
      this.$refs.menu.contextX = e.clientX;
      this.$refs.menu.contextY = e.clientY;
      this.$refs.menu.showContext = true;
      this.constxtID = id;
    });
  }

  async changeElement(id: string): Promise<void> {
    try {
      const result = await this.$bvModal.msgBoxConfirm(
        String(this.$i18n.t("main.confirms.ok")),
        {
          title: String(this.$i18n.t("HotelInfo.confirm.delete")),
        }
      );

      if (result === true) {
        this.deliteinfo(id);
      }
    } catch {
      this.$notify({
        group: "global",
        text: String(this.$i18n.t("error.empty400")),
        type: "warn",
      });
    }
  }

  deliteinfo(id: string): void {
    const url = hotelInfo.force;
    deleteElement(id, url)
      .then(() => {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        this.$emit("deleteElement", id);
      })
      .catch(() => {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("alerts.emptyUpdate")),
          type: "warn",
        });
      });
  }
}
